exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".close-button {\n  display: flex;\n  align-items: center;\n  text-align: right;\n}\n\n.close-button-icon {\n  margin: 5px;\n}\n\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./src/components/CloseButton/main.css
// module id = 770
// module chunks = 0